import { useMemo } from 'react';
import { useCart } from './useCart';
import { LineItem } from './cart.rest';

export const isLineItemAvailableNow = (lineItem: LineItem) =>
  lineItem.attributes.isProductAvailable &&
  !lineItem.attributes.error &&
  lineItem.attributes.isAvailableNow;

export const useCartItems = () => {
  const { cart } = useCart();
  const cartItems = useMemo(() => cart.attributes.cartItems.map(item => item.data), [cart]);

  const availableNowItems = useMemo(() => cartItems.filter(isLineItemAvailableNow), [cartItems]);

  const preorderItems = useMemo(
    () =>
      cartItems.filter(
        item =>
          item.attributes.isProductAvailable &&
          !item.attributes.error &&
          !item.attributes.isAvailableNow
      ),
    [cartItems]
  );

  const unavailableItems = useMemo(
    () => cartItems.filter(item => !item.attributes.isProductAvailable || item.attributes.error),
    [cartItems]
  );

  return {
    cartItems,
    availableNowItems,
    preorderItems,
    unavailableItems
  };
};
